import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { environment } from "environments/environment";
@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  constructor(private http: HttpClient) {}

  login(login: any) {
    const httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http.post<any>(
     "https://swpa211.app/Project211/211/v1/userLogin",
      // environment.baseUrl + "Asbury_Hights1/angular_user_login",

      { phone: login.phone, password: login.password },
      {
        headers: httpHeaders,
      }
    );
  }

 
  logout(): void {
    // remove user from local storage to log user out
    localStorage.setItem("isLoggedIn", "false");
    localStorage.removeItem("currentUser");
  }
}
